export default "__VITE_ASSET__BGee0fP9__"